import { split } from '@apollo/client/core';
import { getMainDefinition } from '@apollo/client/utilities';
import { wsLink } from '@/api/apollo-client/WebSocketLink';
import { link } from '@/api/apollo-client/HttpLink';

export const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  link
);
